/* GREENAPPLE-Helfer 1.1 – Einblenden, Hochzaehlen, Ablauf, Lichtstreif, Buehne anhalten, Kopf kompakt, Zaehler federt. Ohne Bibliotheken. */
(() => {
  const ruhig = matchMedia('(prefers-reduced-motion: reduce)').matches;
  document.documentElement.classList.add('g24-js');
  const fmt = (n, el) => el.dataset.g24Format === 'jahr' ? String(Math.round(n)) : Math.round(n).toLocaleString('de-DE');
  const zaehlen = el => {
    const ziel = parseFloat(el.dataset.g24Zahl), von = parseFloat(el.dataset.g24Von || 0), start = performance.now();
    const schritt = jetzt => { const p = Math.min(1, (jetzt - start) / 1200), e = 1 - Math.pow(1 - p, 3);
      el.textContent = fmt(von + (ziel - von) * e, el); if (p < 1) requestAnimationFrame(schritt); };
    requestAnimationFrame(schritt);
  };
  const sehen = 'IntersectionObserver' in window ? new IntersectionObserver(es => es.forEach(e => {
    if (!e.isIntersecting) return;
    sehen.unobserve(e.target); e.target.classList.add('ist-sichtbar');
    if (e.target.hasAttribute('data-g24-zahl') && !ruhig) zaehlen(e.target);
  }), {threshold: 0.25, rootMargin: '0px 0px -8% 0px'}) : null;
  document.querySelectorAll('.g24-einblenden,[data-g24-zahl],[data-g24-ablauf]').forEach(el => ruhig || !sehen ? el.classList.add('ist-sichtbar') : sehen.observe(el));
  document.querySelectorAll('[data-g24-nochmal]').forEach(k => k.addEventListener('click', () => {
    const a = k.closest('[data-g24-ablauf]'); if (!a) return;
    a.classList.remove('ist-sichtbar'); void a.offsetWidth; a.classList.add('ist-sichtbar');
  }));
  if (!ruhig) document.querySelectorAll('.g24-streif').forEach(k => [1200, 4000].forEach(t => setTimeout(() => {
    k.classList.remove('laeuft'); void k.offsetWidth; k.classList.add('laeuft');
  }, t)));
  let aus = false; try { aus = localStorage.getItem('g24-bewegung') === 'aus'; } catch (_) {}
  document.querySelectorAll('[data-g24-anhalten]').forEach(k => {
    const b = k.closest('.g24-buehne'); if (!b) return; // Knopf ausserhalb einer Buehne: nichts tun, Rest laeuft weiter
    const setzen = an => { b.classList.toggle('ist-angehalten', an); k.setAttribute('aria-pressed', String(an));
      k.setAttribute('aria-label', an ? 'Bewegung fortsetzen' : 'Bewegung anhalten');
      k.querySelectorAll('[data-zeigt]').forEach(s => s.toggleAttribute('hidden', (s.dataset.zeigt === 'aus') !== an)); };
    setzen(aus);
    k.addEventListener('click', () => { const an = k.getAttribute('aria-pressed') !== 'true'; setzen(an);
      try { localStorage.setItem('g24-bewegung', an ? 'aus' : 'an'); } catch (_) {} });
  });
  const kopf = document.querySelector('.g24-kopf');
  if (kopf) { let geplant = false; const pruefen = () => { kopf.classList.toggle('ist-kompakt', scrollY > 80); geplant = false; };
    addEventListener('scroll', () => { if (!geplant) { geplant = true; requestAnimationFrame(pruefen); } }, {passive: true}); pruefen(); }
  document.querySelectorAll('.g24-zaehler').forEach(z => new MutationObserver(() => {
    z.classList.remove('springt'); void z.offsetWidth; z.classList.add('springt');
  }).observe(z, {childList: true, characterData: true, subtree: true}));
})();
